import React from 'react';
import Icon from '../atoms/Icon';

function APIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 28 32">
      <g>
        <path d='M0.000198364 28.6591H27.6463V0H0.000198364V28.6591Z' fill='white'/>
        <path d='M0 28.6591H27.6464V32H0.000266686L0 28.6591Z' fill='#FF322E'/>
        <path d='M6.36351 7.54156L1.71634 21.4796H5.08102L8.23751 11.6277L9.81958 16.5531H7.77303L6.95573 19.3647H10.7227L11.4019 21.4796H14.8628L10.2161 7.54156H6.36351Z' fill='black'/>
        <path d='M20.1501 7.54156H15.3193V21.4796H18.66V10.3533H20.0062C21.5681 10.3533 22.4574 11.098 22.4574 12.4439C22.4574 13.7656 21.5681 14.5346 20.0062 14.5346H19.7899V17.3463H20.1501C23.7551 17.3463 25.8701 15.5317 25.8701 12.4439C25.8701 9.29581 23.7551 7.54156 20.1501 7.54156Z' fill='black'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(APIcon);
